import { create } from 'zustand';

export type NavigationState = {
  previousPath: string | undefined;
  currentPath: string | undefined;
};

type NavigationActions = {
  setPaths: (currentPath: string | undefined) => void;
};

type NavigationStore = NavigationState & NavigationActions;

const initialState: NavigationState = {
  previousPath: undefined,
  currentPath: undefined,
};

export const useNavigationStore = create<NavigationStore>()((set) => ({
  ...initialState,
  setPaths: (currentPath) => set((state) => ({ previousPath: state.currentPath, currentPath })),
}));
